var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.25 5.23c0 .166.083.332.167.416l4.166 4.167c.25.25.667.25.917 0a.654.654 0 000-.917l-3.75-3.75 3.75-3.75a.654.654 0 000-.917.654.654 0 00-.917 0L.417 4.646c-.084.333-.167.5-.167.583z",
    fill: "#fff"
  })));
}
export default SvgArrowBack;